import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, selectSx } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';

const COLS = ['Nome', 'Status', 'Email', 'CPF / CNPJ', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

const StatusBadge = ({ status }) => {
  return (
    <span style={{
      display: 'inline-block', padding: '2px 12px', borderRadius: 40,
      background: status == '1' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
      color: status == '1' ? '#059669' : '#dc2626',
      fontSize: 11, fontWeight: 600,
    }}>
      {status == '1' ? 'Ativo' : 'Inativo'}
    </span>
  );
};

export default function ListaRepresentante() {
  const [search, setSearch]   = useState('');
  const [status, setStatus]   = useState('-1');
  const [perPage, setPerPage] = useState(25);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = (s = status, pp = perPage, q = search) => {
    setLoading(true);
    axios.get(
      `${Apis.urlListarRepresentantes}?pesquisa=${q}&status=${s}&qtd_registros=${pp}`,
      { headers: headers() }
    )
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(status, val); };

  const Toolbar = (
    <select value={status} onChange={e => { const v = e.target.value; setStatus(v); fetchData(v); }} style={selectSx}>
      <option value="-1">Todos os status</option>
      <option value="1">Ativos</option>
      <option value="0">Inativos</option>
    </select>
  );

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Representantes"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por nome, email, CPF/CNPJ…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      toolbar={Toolbar}
      fab={{ show: true, label: 'representante', path: 'cadastrar-representante/0' }}
      emptyMessage="Nenhum representante encontrado para os filtros aplicados."
    >
      {data.map((c, i) => (
        <tr key={c.id}
          style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
        >
          <TD left uppercase>{c.nome}</TD>
          <TD><StatusBadge status={c.status} /></TD>
          <TD>{c.email}</TD>
          <TD>{c.cnpj_cpf}</TD>
          <TD>
            <Actions>
              <EditBtn to={`/alterar-representante/${c.id}`} />
              <DeleteBtn url={Apis.urlDeletarRepresentantes} id={c.id} redirect="listar-representantes" component="Representante" texto={`Deseja realmente excluir o representante ${c.nome}`} />
            </Actions>
          </TD>
        </tr>
      ))}
    </TableLayout>
  );
}
